import type { Embedder, ScoredRecord, VectorStore } from '@fim/futurex-vector';
import type { Chunk } from './types.js';

/** Embed the query and return the top-K most similar chunks. */
export async function retrieve(
  store: VectorStore<Chunk>,
  embedder: Embedder,
  query: string,
  topK: number,
): Promise<ScoredRecord<Chunk>[]> {
  if (topK <= 0 || (await store.size()) === 0) return [];
  const vectors = await embedder.embed([query]);
  const vec = vectors[0];
  if (!vec) return [];
  return store.query(vec, topK);
}
